export default "__VITE_ASSET__CDlGvxhN__"